import service from '@/plugins/service'

const machineApi = {}

const baseURL = '/customer_profile'

machineApi.getMachineList = (custId, curentPage, size) => {
  return service({
    url: `${baseURL}/report/list/${custId}/${curentPage}/${size}`,
    method: 'get'
  })
}
machineApi.addMachineList = (data) => {
  return service({
    url: `${baseURL}/report/save`,
    method: 'post',
    data
  })
}
machineApi.removeMachine = (ids) => {
  const formData = new FormData()
  ids.forEach(id => formData.append('id', id))
  return service({
    url: `${baseURL}/report/delete`,
    method: 'post',
    data: formData
  })
}

export default machineApi
